<template>
  <i-dx-popup :popup-visible="popupVisible" :title="$t('selectPerson')" @popupCloseButtonClick="$emit('popupClose')" :height="'685'" width="962px">
    <template v-slot:grid>
      <div class="v-application" style="display: block !important; padding: 8px;">
        <v-row no-gutters>
          <v-col cols="12" sm="12" lg="12" class="pa-0">
            <i-card-top class="d-md-flex" headerTitle="" :useBtnList="buttonUseList" @btnSearch="btnSearch()">
              <template v-slot:body>
                <v-layout>
                  <v-row no-gutters class="pa-2 py-3">
                    <v-col cols="12" md="4" class="py-2 py-md-0">
                      <v-autocomplete
                        v-model="riskAssRole"
                        class="mx-1"
                        item-text="minorNm"
                        item-value="minorCd"
                        :menu-props="{ offsetY: true }"
                        :items="riskAssRoleList"
                        :placeholder="$t('riskEvaluationRole')"
                        dense
                        outlined
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="emergOrgnGrp"
                        class="mx-1"
                        item-text="minorNm"
                        item-value="minorCd"
                        :menu-props="{ offsetY: true }"
                        :items="emergOrgnGrpList"
                        :placeholder="$t('emergencyGroup')"
                        dense
                        outlined
                        clearable
                      />
                    </v-col>
                  </v-row>
                </v-layout>
              </template>
            </i-card-top>
          </v-col>
        </v-row>
        <v-row no-gutters class="px-4">
          <v-col cols="12" md="7">
            <i-card-vertical :headerTitle="$t('humanResourceList')">
              <template v-slot:body>
                <v-layout column>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <DxDataGrid
                        :data-source="dataSource"
                        :ref="dxDataGridRef"
                        width="100%"
                        :editing="{
                          allowUpdating: false
                        }"
                        :height="485"
                        :paging="{ pageSize: 10 }"
                        :pager="{ allowedPageSizes: [10, 'all'], showInfo: false }"
                        key-expr="id"
                      >
                        <DxColumn data-field="korNm" :caption="$t('name')" width="80px" data-type="string" alignment="center"> </DxColumn>

                        <DxColumn data-field="jbrpName" :caption="$t('position')" width="80px" data-type="string" alignment="center"> </DxColumn>

                        <DxColumn data-field="riskAssRole" :caption="$t('riskEvaluationRole')" width="130px" data-type="string" alignment="left">
                        </DxColumn>

                        <DxColumn data-field="emergOrgnGrp" :caption="$t('emergencyGroup')" width="120px" data-type="string" alignment="left">
                        </DxColumn>

                        <DxColumn
                          name="selectButton"
                          :caption="$t('select')"
                          type="buttons"
                          width="50px"
                          alignment="center"
                          cell-template="selectButton"
                        />

                        <template #selectButton="{ data: cellInfo }">
                          <v-btn text class="move" x-small color="btn_sub" @click="onHrSelect(cellInfo)">
                            <svg-icon icon-class="check" style="height: 1rem;"></svg-icon>
                          </v-btn>
                        </template>
                      </DxDataGrid>
                    </v-col>
                  </v-row>
                </v-layout>
              </template>
            </i-card-vertical>
          </v-col>
          <v-col cols="12" md="1" style="align-self: center; text-align: center;">
            <v-row no-gutters class="mb-5">
              <v-col cols="6" md="12">
                <v-btn color="primary" icon @click="onListToGridClick">
                  <v-icon>
                    mdi-arrow-left-bold
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="6" md="12">
                <v-btn color="primary" icon @click="onGridToListClick">
                  <v-icon>
                    mdi-arrow-right-bold
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <div class="font-weight-bold card_title--text text-lg-h6 text-sm-h5 body-1 pa-0">
              {{ $t('selectedPersonnel') }}
            </div>
            <v-card outlined :height="434">
              <DxList
                ref="dxlist"
                id="simple-dxlist"
                :dataSource="selectedHrList"
                :repaint-changes-only="true"
                key-expr="id"
                show-scrollbar="always"
                :allow-item-deleting="true"
                :show-selection-controls="true"
                :search-enabled="true"
                :item-delete-mode="'static'"
                selection-mode="all"
                searchExpr="text"
                select-all-mode="allPages"
              >
              </DxList>
              <v-btn elevation="0" height="32" small dark color="btn_sub" class="rounded mt-3 font-weight-bold" width="100%" @click="btnApply">
                {{ $t('apply') }}
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import { DxDataGrid, DxColumn, DxLookup } from 'devextreme-vue/data-grid'
import { DxList } from 'devextreme-vue/list'
import { getEsgHrInfoList } from '@/api/component/component.js'
import { getCommonCode } from '@/api/common/commonApi'
import iCardTop from '@/components/common/iCardTop.vue'

import DxTreeView from 'devextreme-vue/tree-view'

import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup,
    DxDataGrid,
    DxColumn,
    DxLookup,
    DxList,
    'i-card-top': iCardTop
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    cellInfo: {
      type: Object,
      default: () => null
    },
    defaultHrList: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {
      dxDataGridRef: 'popUpDataGrid',
      gridData: [],
      hrList: [],
      korNm: '',
      riskAssRole: '',
      riskAssRoleList: [],
      emergOrgnGrp: '',
      emergOrgnGrpList: [],
      selectedHrList: [],
      buttonUseList: [
        'btnSearch' //조회
      ]
    }
  },
  computed: {
    dataSource() {
      let alreadySelectedEsgHrNo = []
      this.selectedHrList.forEach(element => alreadySelectedEsgHrNo.push(element.id))
      return this.hrList.filter(element => !alreadySelectedEsgHrNo.includes(element.id) && element.useYn === 'Y')
    },
    selectedHrNo() {
      let result = []
      this.selectedHrList.forEach(element => result.push(element.id))
      return result.join()
    }
  },
  async mounted() {
    this.setComboBoxData()
    await this.btnSearch()

    let initArray = []
    // 초기값 세팅
    if (typeof this.defaultHrList == 'string') {
      initArray = this.defaultHrList.split(',')
    } else {
      initArray = this.defaultHrList ? this.defaultHrList : [] // 20230428 JDH 참석대상 null 체크
    }

    this.selectedHrList = this.hrList.filter(element => initArray.includes(element.id))
    this.selectedHrList.forEach(element => (element.text = element.korNm + '(' + (element.riskAssRole == null ? '기타' : element.riskAssRole) + ')'))
  },
  methods: {
    ///////////////////////////////////////
    /*        Toolbar Button Event       */
    ///////////////////////////////////////
    btnSearch() {
      return new Promise(async (resolve, reject) => {
        if (!this.$refs[this.dxDataGridRef]) return

        this.gridInit(this.GetDataGrid(this.dxDataGridRef))

        this.openLoading('searching')

        let searchParams = {
          compId: this.getCompId(),
          korNm: this.korNm,
          riskAssRole: this.riskAssRole,
          emergOrgnGrp: this.emergOrgnGrp
        }

        getEsgHrInfoList(searchParams, true)
          .then(res => {
            this.hrList = []
            this.hrList = res.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          })
          .finally(() => {
            this.endLoading()
            resolve(true)
          })
      })
    },
    btnApply() {
      if (this.selectedHrList.length == 0) {
        this.vToastifyPrompt(
          this.$t('msgNoHrSelect'),
          'info',
          current => {
            this.$emit('apply', this.selectedHrNo, this.cellInfo)
          },
          null,
          true
        )
      } else {
        this.$emit('apply', this.selectedHrNo, this.cellInfo)
      }
    },
    ///////////////////////////////////////
    /*           grid Event              */
    ///////////////////////////////////////
    onHrSelect(cellInfo) {
      let data = cellInfo.data
      let index = this.selectedHrList.findIndex(element => element.id == data.id)
      if (index >= 0) return

      data.text = `${data.korNm}(${data.riskAssRole})`

      this.selectedHrList.push(data)

      let alreadySelectedEsgHrNo = []
      this.selectedHrList.forEach(element => alreadySelectedEsgHrNo.push(element.id))
    },
    ///////////////////////////////////////
    /*           tree List Event         */
    ///////////////////////////////////////
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    // 오른쪽 화살표 버튼 (그리드에서 리스트로)
    async onGridToListClick() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()

      selectedRows.forEach(element => {
        element.text = `${element.korNm}(${element.riskAssRole})`
        this.selectedHrList.push(element)
      })
      this.GetDataGrid(this.dxDataGridRef).deselectAll()
    },
    // 왼쪽 화살표 버튼 (리스트에서 그리드로)
    onListToGridClick() {
      let selectedItemKeys = this.$refs.dxlist.instance.option('selectedItemKeys')
      this.selectedHrList = this.selectedHrList.filter(element => !selectedItemKeys.includes(element.id))
      // 선택 초기화
      this.$refs.dxlist.instance.option('selectedItemKeys', [])
    },
    setComboBoxData() {
      Promise.all([
        getCommonCode('C0009'), // 위험성평가 조직역할
        getCommonCode('C0014') // 비상통제 조직역할
      ]).then(response => {
        this.riskAssRoleList = response[0].list
        this.emergOrgnGrpList = response[1].list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn--outlined {
  // background: #ffffff !important;
  // border: 1px solid #9e9e9e;
  font-size: 11px;
  height: 25px;
  line-height: 1.2;
  border-radius: 0;
}

.dx-texteditor.dx-editor-outlined {
  background: #f1f3fe !important;
}
</style>
